export default __webpack_public_path__ + "static/media/cp_geo_hk.5043f05f.svg";